module.exports = __webpack_public_path__ + "img/img_profile.bf92ed6d.svg";